export default __webpack_public_path__ + "static/media/desktopLanding.2fd52a6d.png";